export const SDK_VERSION = '6.9.0';
